import type { MRT_ColumnDef } from "mantine-react-table-open";
import { isNumberStringValid } from "../../../../../mantine/mrt/validation/isNumberStringValid";
import type { InlineEditTableColumnData } from "../../../../../types/inlineEditTable.types";
import type { PPAInvoiceNumberRange } from "../../PPAInvoiceNumberRangesPage.types";

export function getCounterStartOffsetColumn({
  validationErrors,
  setValidationErrors,
  t
}: InlineEditTableColumnData): MRT_ColumnDef<PPAInvoiceNumberRange> {
  return {
    accessorKey: "counter_start_offset",
    header: "Startwert des Nummernkreises",
    enableSorting: false,
    mantineEditTextInputProps: () => ({
      "aria-label": "Startwert des Nummernkreises",
      error: validationErrors.counter_start_offset,
      placeholder: "Bsp.: 1",
      required: true,
      type: "string",
      onChange: (event) => {
        const value = event.target.value;

        if (!isNumberStringValid(value)) {
          setValidationErrors({
            ...validationErrors,
            counter_start_offset: t(
              "errors.NumberRanges.counterStartValueError"
            )
          });
        } else {
          delete validationErrors.counter_start_offset;
          setValidationErrors({ ...validationErrors });
        }
      }
    }),
    minSize: 150,
    size: 300
  };
}
